module.exports = __webpack_public_path__ + "img/bg-blog-detail.0525d2c1.png";